const filtersPerso = [
  {
    id: 'updatedDate',
    translateKey: 'updated_date',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: false,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'date'
  },
  {
    id: 'type',
    translateKey: 'type',
    options: ['obu', 'dtco'],
    values: '',
    isOpen: true,
    displayTextfield: false,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'string'
  },
  {
    id: 'deviceIds',
    translateKey: 'device_id',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'createdDate',
    translateKey: 'created_date',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: false,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'date'
  },
  {
    id: 'operationType',
    translateKey: 'operation_type',
    options: ['auto', 'api'],
    values: '',
    isOpen: true,
    displayTextfield: false,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'string'
  },
  {
    id: 'triggers',
    translateKey: 'trigger',
    options: ['dat', 'geometry', 'instance', 'subscription', 'vehicle', 'deperso', 'configuration', 'variant'],
    values: [],
    isOpen: true,
    displayTextfield: false,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'multi_string'
  },
  {
    id: 'variantNames',
    translateKey: 'variants',
    options: [],
    values: [],
    isOpen: true,
    displayTextfield: true,
    displaySearchBar: false,
    searchQuery: '',
    inputType: 'multi_string'
  }
];

export default filtersPerso;
